import React, { useState, useEffect } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFileAlt,
  faEye,
  faArrowDown,
} from "@fortawesome/free-solid-svg-icons"
import Modal from "react-bootstrap/Modal"
import Box from "@mui/material/Box"
import moment from "moment"
import Button from "components/Button/Button"
import PDFViewer from "components/PdfViewer/PdfViewer"
import { useTheme } from "@emotion/react"
import { styles } from "resources/styles/Styles"
import { PatientDetailStyles } from "resources/styles/pages/PatientDetailStyles"
import { downloadHistoricalDocuments, getHistoricalDocumentsUrl } from "core/services/api"
import Toast from "components/Toast"
import fileUtils from "fileUtils"

function HistoricalDocuments({
  patient,
}: any) {
  const theme = useTheme()
  const globalStyles = styles(theme)
  const classes = PatientDetailStyles(theme)
  const [accordion, updateAccordion] = React.useState<any | null>()
  const [sections, setSections] = useState<any>([])
  const [selectedSection, setSelectedSection] = useState<any>("")
  const [documentsList, setDocumentsList] = useState<any>([])
  const [selectedPdf, setSelectedPdf] = useState<any>("")
  const [show, setShow] = useState<any>(false)
  const [loading, setLoading] = useState<any>(false)
  const [displayToast, setDisplayToast] = useState<any>(false)

  useEffect(() => {
    if (patient?.oldDocuments) {
      const keys = patient?.oldDocuments?.map((each: any) => each?.category)
      setSections(keys?.sort())
    }
  }, [])

  useEffect(() => {
    if (patient?.oldDocuments) {
      if (selectedSection) {
        const foundObj = patient?.oldDocuments?.find((each: any) => each?.category === selectedSection)
        if (foundObj) {
          if (foundObj?.mocDocumentList) {
            setDocumentsList(foundObj?.mocDocumentList)
          }
        }
      }
    }
  }, [selectedSection])

  const downloadFiles = () => {
    // setLoading(true)
    downloadHistoricalDocuments(patient?.id, selectedSection)
      .then((res: any) => {
        getZipUrl()
      })
      .catch((err: any) => {
        console.log(err?.message)
        setLoading(false)
        setDisplayToast({
          text: "Failed to download",
          type: "error"
        })
      })
  }

  const getZipUrl = async () => {
    const intervalIds: any = [];
    let apiSuccess = false;

    const clearAllIntervals = () => {
      intervalIds?.forEach((id: any) => clearInterval(id));
      intervalIds.length = 0;
    };

    const successCallback = (blobUrl: any) => {
      apiSuccess = true;
      clearAllIntervals();
      setLoading(false);
      const filename = blobUrl?.substring(blobUrl?.lastIndexOf("/") + 1);
      fileUtils?.downloadFileViaUrl(blobUrl, filename);
      setDisplayToast({
        text: "Downloaded Successfully",
        type: "success",
      });
    };

    intervalIds.push(
      setInterval(async () => {
        getHistoricalDocumentsUrl(patient?.id, selectedSection)
          .then(async (res) => {
            if (!apiSuccess && res?.status === "SUCCESS") {
              successCallback(res?.blobUrl);
            }
          })
          .catch((err) => {
            setLoading(false);
            clearAllIntervals();
            if (!apiSuccess) {
              setDisplayToast({
                text: "Failed to download",
                type: "error",
              });
            }
          });
      }, 5000)
    );

    setTimeout(() => {
      if (!apiSuccess) {
        setLoading(false);
        clearAllIntervals();
        setDisplayToast({
          text: "Failed to download",
          type: "error",
        });
      }
    }, 60000);
  };

  const downloadSpecificFile = (file: any) => {
    var link = document.createElement('a');
    link.href = file.blobUrl;
    link.download = file.name;
    link.click();
  }

  function renderDocumentsList() {
    return (
      <div className="pedigree-docs-container">
        {documentsList.length > 0 &&
          documentsList.map((ele: any) => {
            const formattedDate = ele?.createdAt ? moment(ele?.createdAt?.split('T')[0], 'YYYY-MM-DD').format('DD-MM-YYYY') : ""
            return (
              <div className="file-list">
                <span>
                  <FontAwesomeIcon
                    className="doc-icon"
                    size="4x"
                    icon={faFileAlt}
                  />
                </span>
                <div className="file-name">{ele?.name}</div>
                {/* <div>{formattedDate}</div> */}
                <span style={{ height: "35px", cursor: "pointer" }} >
                  <FontAwesomeIcon
                    className="delete-icon"
                    icon={faEye}
                    height={35}
                    width={35}
                    onClick={() => {
                      setSelectedPdf(ele)
                      setShow(true)
                    }}
                  />
                </span>
                <a
                  // href={ele?.blobUrl}
                  onClick={() => fileUtils.downloadFile(ele)}
                // download={ele?.name}
                >
                  <FontAwesomeIcon
                    className="download-icon"
                    icon={faArrowDown}
                  />
                </a>
              </div>
            )
          })}
      </div>
    )
  }

  function renderDownloadAll() {
    return (
      <>
        {
          documentsList?.length > 0 && (
            <div className="d-flex justify-content-end mt-3">
              <Button text="Download All" id="download-all"
                onClick={(e: any) => downloadFiles()} />
            </div>
          )
        }
      </>
    )
  }

  function renderAccordion(
    eachSection: any,
    index: number
  ) {

    return (
      <>
        <div
          style={{ cursor: "pointer" }}
          className={classes.accordionDischargeSummary}
          onClick={() => handleChange(eachSection, index)}
        >
          <div className={`${classes.accordionHeader} col-md-12 row p-0 m-0`}>
            <div className={`col-md-7 col-lg-6 p-0`}>
              <div className={classes.appContentTitleDischargeSummary}>Category: {eachSection}</div>
            </div>
            <div className={`col-md-5 col-lg-6 p-0`}>
              <div className={`${classes.accRightSectionDocuments}`}>
                <div className={`${classes.pl30}`}>
                  <img
                    className={globalStyles.pointer}
                    src={
                      accordion === index
                        ? "../../../assets/images/chevronUpIcon.svg"
                        : "../../../assets/images/chevronDownIcon.svg"
                    }
                    alt={accordion === index ? "upArrow" : "downArrow"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {accordion === index && (
          <div className={`${classes.accordionContent}`}>
            {documentsList?.length > 0 ? (
              <>
                {renderAccordionContentRow()}
              </>
            ) : (
              <div className={classes.noDataState}>No data available.</div>
            )}
          </div>
        )}
      </>
    )
  }

  function handleChange(panel: any, index: any) {
    setSelectedSection(panel)
    updateAccordion(index !== accordion ? index : false)
  }

  function renderAccordionContentRow() {
    return (
      <div className="col-md-12 mt-2 p-2 mb-2 row">
        <div className={`${classes.accordionEachRow} col-md-12 m-0 p-0 row`}>
          {
            renderDownloadAll()
          }
          {
            renderDocumentsList()
          }
        </div>
      </div>
    )
  }

  return (
    <div className="pedigree-container">
      {
        loading ? (
          <div
            style={{
              position: "absolute",
              top: "25%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "2rem", height: "2rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        ) : displayToast ? (
          <Toast
            textMessage={displayToast?.text}
            type={displayToast?.type}
            onClose={() => setDisplayToast(false)}
            onCloseText="Close"
            onClickText={null}
          />
        ) : null
      }
      {sections && sections?.length > 0 ? (
        sections?.map((section: any, index: any) =>
          renderAccordion(section, index)
        )
      ) : (
        <div className={`${classes.noDataState}`}>
          No documents available.
        </div>
      )}
      {
        show && (
          <Modal size="xl" show={show} onHide={() => {
            setSelectedPdf("")
            setShow(false)
          }}>
            <Modal.Header closeButton>
              {`${selectedSection?.toUpperCase()} - ${selectedPdf?.name}`}
            </Modal.Header>
            <Modal.Body>
              <Box sx={{ width: "100%", marginTop: "20px" }}>
                {
                  selectedPdf?.blobUrl?.substring(selectedPdf?.blobUrl?.lastIndexOf('.') + 1) === "pdf" ?
                    <PDFViewer url={selectedPdf?.blobUrl} noBorder={true} />
                    :
                    <img
                      src={selectedPdf?.blobUrl}
                      style={{ width: "100%", height: "100%" }}
                      alt={selectedPdf?.name}
                    />
                }
              </Box>
            </Modal.Body>
          </Modal >
        )
      }
    </div>
  )
}

export default HistoricalDocuments
